import { useMutation } from '@apollo/client';

import { useCurrentEventQuery } from '../../event/hooks/useCurrentEventQuery';
import { useToast } from '../../toast/Toast.context';
import {
  JOIN_CARPOOL_TRIP,
  JoinCarpoolTripMutation,
  JoinCarpoolTripMutationVariables,
} from '../graphql/mutation/joinCarpoolTripMutation.graphql';
import {
  CARPOOL_TRIPS,
  CarpoolTripsQueryVariables,
} from '../graphql/query/carpoolTripsQuery.graphql';

export const useJoinCarpoolTripMutation = () => {
  const { data: currentEventData } = useCurrentEventQuery();
  const { showToast } = useToast();
  const [mutate] = useMutation<
    JoinCarpoolTripMutation,
    JoinCarpoolTripMutationVariables
  >(JOIN_CARPOOL_TRIP);

  const joinCarpoolTrip = async (tripId: string) => {
    const eventId = currentEventData?.currentEvent?.id;
    if (!eventId) {
      return;
    }

    await mutate({
      variables: { tripId },
      refetchQueries: [
        {
          query: CARPOOL_TRIPS,
          variables: { eventId } satisfies CarpoolTripsQueryVariables,
        },
      ],
    });

    showToast({
      type: 'success',
      message: 'Trajet rejoint.',
    });
  };

  return { joinCarpoolTrip };
};
